export default {"src":"/_next/static/media/bank.e8d439d6.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};